import React from "react";
import Grid from "@mui/material/Grid";
import { QAMacCard } from "components/User/Mac";
import { connect } from "react-redux";
import PropTypes from "prop-types";


const QAMac = (
  {
    internetUserId
  }
) => {
  return (
    <Grid container spacing={2} className="case-header mac-page no-padding">
      <Grid item xs={12}>
        <QAMacCard 
          internetUserId={internetUserId}
        />
      </Grid>
    </Grid>
  );
};

QAMac.propTypes = {
  internetUserId: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    internetUserId: state.user.profile.internetUserId,
  };
};

export default connect(mapStateToProps)(QAMac);